// libs
import React, {useState} from 'react';
import { useTranslation } from "react-i18next";
import {toast} from "react-toastify";
import Notice24H from "./Notice24h";
import axios from "../../../../../axios-defaults";
import Spinner from "../../../../UI/Spinner";

const SaveCardPanel = (props) => {
    const { t } = useTranslation();
	const [loading, setLoading] = useState(false);

	const submitHandler = (submitData) => {
		setLoading(true);

		axios.patch(`/cards/updateCreditCard`,submitData)
            .then(response => {
				if (response.data.succeeded) {
					toast.success(
						<div>
							<i className="fas fa-check-circle"></i>&nbsp;&nbsp;{t('account.cards.management.confirm.success')}
						</div>
					);
					props.closeModal();
					props.reloadCardSummary();
				}
				setLoading(false);
            })
            .catch(error => {
                toast.error(
                    <div>
                        <i className="fal fa-exclamation-circle"></i>&nbsp;{error.response.data ? error.response.data.message : error.message }
                    </div>
                );
                console.log('[SaveCardPanel.js] : Ajax error in submitHandler()',error.message);
				setLoading(false);
		    });
    }
    return (
		loading ? <Spinner/> :
			<div className="cardmanager__inner">
            <h2 className="headline headline--section headline--uppercase">
                {t('account.cards.management.confirm.title')}
            </h2>
            <Notice24H />
            <form className="form mt-4" onSubmit={(e) => { e.preventDefault(); }}>
                <fieldset className="fieldset form__actions">
                    <button className="btn btn--outline btn--outline--gray action" onClick={props.cancelAction}>
                        <span className="btn__text">
                            { t('account.cards.management.buttons.cancel') }
                        </span>
                    </button>
                    <button type="submit" className="btn btn--raised btn--raised--red action" onClick={()=> submitHandler(props.submitData)}>
                        <span className="btn__text">
                            { t('account.cards.management.buttons.confirm') }
                        </span>
                    </button>
                </fieldset>
            </form>
        </div>
    );
};

export default SaveCardPanel;
